module.exports = __webpack_public_path__ + "static/media/thumbnail.f7210d8a.jpg";